module.exports = false;


// WEBPACK FOOTER //
// ./~/core-js/modules/_library.js